/* =============================================================
   SidebarContext.js — Sidebar open/collapsed state
   -------------------------------------------------------------
   Provides a single boolean (open) and a toggle() function so
   any component can read or change the sidebar width without
   prop-drilling.

   Used by: Sidebar, StudentSidebar, Layout, StudentLayout,
            Header, and any component that needs to offset its
            position based on sidebar width.
   ============================================================= */

import { createContext, useContext, useState } from 'react';


/* -------------------------------------------------------------
   CONTEXT SETUP
   ------------------------------------------------------------- */
const SidebarContext = createContext();


/* -------------------------------------------------------------
   SIDEBAR PROVIDER
   Defaults to open (expanded) on first load.
   ------------------------------------------------------------- */
export function SidebarProvider({ children }) {
  const [open, setOpen] = useState(true);

  return (
    <SidebarContext.Provider value={{ open, toggle: () => setOpen(v => !v) }}>
      {children}
    </SidebarContext.Provider>
  );
}


/* -------------------------------------------------------------
   useSidebar HOOK
   Shortcut to access sidebar state from any component:
   const { open, toggle } = useSidebar();
   ------------------------------------------------------------- */
export function useSidebar() {
  return useContext(SidebarContext);
}
